module.exports = {

};


// WEBPACK FOOTER //
// ./src/store/global/getters.js